const endpoint = import.meta.env.VITE_METRICS_URL;

type MetricEvent = {
  type: 'intent';
  name: string;
  cid: string;
  ackMs?: number;
  resultMs?: number;
  ok?: boolean;
};

const sentAt = new Map<string, number>();
const ackAt = new Map<string, number>();

const now = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now());

export function recordIntentSent(cid: string) {
  sentAt.set(cid, now());
}

export function recordAck(cid: string) {
  ackAt.set(cid, now());
}

export function recordResult(cid: string, ok: boolean) {
  const sent = sentAt.get(cid);
  const ack = ackAt.get(cid);
  if (!sent || !endpoint || typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') {
    sentAt.delete(cid);
    ackAt.delete(cid);
    return;
  }

  const payload: MetricEvent = {
    type: 'intent',
    name: cid.split('_')[0],
    cid,
    ackMs: ack ? ack - sent : undefined,
    resultMs: now() - sent,
    ok
  };

  try {
    navigator.sendBeacon(endpoint, JSON.stringify(payload));
  } catch (error) {
    console.warn('[metrics] beacon failed', error);
  }

  sentAt.delete(cid);
  ackAt.delete(cid);
}
